import React, { useMemo } from 'react';
import { useLocaleContext } from '../../../../context/LocaleContext';
import { TYPE_OFFLINE, TYPE_ONLINE } from '../../../../constants/common';
import Icons from '../../../Icons';

import './style.scss';

const ScheduleHeaderActions = ({
    episode,
    isFormatVisible = true,
    isCalendarVisible = true,
    isBookmarkVisible = true,
    bookmarkEpisodeIds = [],
    handleBookmark,
}) => {
    const $locale = useLocaleContext();
    const episodeParticipationType = useMemo(() => {
        if (episode.displayParticipationType === TYPE_ONLINE) return 'participationType.online'; 
        if (episode.displayParticipationType === TYPE_OFFLINE) return 'participationType.offline';

        return 'participationType.hybrid';
    }, [episode]);

    const onBookmark = (e) => {
        e.stopPropagation();
        handleBookmark(episode.id);
    }

    if (!isFormatVisible && !isCalendarVisible && !isBookmarkVisible) {
        return null;
    }

    const isBookmark = bookmarkEpisodeIds.includes(episode.id);
    
    return(
        <div className="schedule-card-header-actions">
            {
                isFormatVisible &&
                <div className="schedule-card-header-actions__episode-type">
                    {$locale.get(episodeParticipationType)}
                </div>
            }
            {   isCalendarVisible &&
                <a
                    href={`/api/player/episode/${episode.id}/calendar.ics`}
                    className="schedule-card-header-actions__episode-calendar"
                    target="_blank"
                    onClick={(e) => e.stopPropagation()}
                >
                    <Icons name="calendar" />
                </a>
            }
            {
                isBookmarkVisible &&
                <div
                    className={`schedule-card-header-actions__episode-bookmark ${isBookmark ? '-is-bookmark' : ''}`}
                    onClick={onBookmark}
                >
                    <Icons name="bookmark" />
                </div>
            }
        </div>
    )
};

export default ScheduleHeaderActions;
